import Joi from 'joi-browser';

const adminValidation = {
  name: Joi.string()
    .label('Nombre')
    .trim()
    .max(255)
    .required(),
  biography: Joi.string()
    .label('Biografía')
    .required(),
  website: Joi.string()
    .label('Sitio Web')
    .uri({
      scheme: ['http', 'https'],
    })
    .required(),
};

export default adminValidation;



// WEBPACK FOOTER //
// ./src/containers/Profile/EditProfile/adminValidation.js